import { AssistantField } from '@kizenapps/engine';
import { useMemo } from 'react';
import QRCode from 'react-qr-code';
import { getQrCodeValue } from '@kizenapps/engine/util';
import { useSelector } from 'react-redux';
import { getParamFromAuth } from './util';

export const QRBlock = ({ field }: { field: AssistantField }) => {
  const auth = useSelector((state: any) => state.authentication);

  const qrValue = useMemo(() => {
    const val = getQrCodeValue(
      field.value,
      field.include,
      getParamFromAuth(auth)
    );

    return val;
  }, [field.value, field.include, auth]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        position: 'relative',
      }}
    >
      <QRCode value={qrValue} size={field.size || 128} />
    </div>
  );
};
